<template>
  <v-text-field
      :error-messages="error"
      :label="translation(translationList.company_name, 'Nume companie')"
      v-model="companyName"
      :rules="companyNameValidationRules"
      name="companyName"
      variant="outlined"
      :tile="true"
  >
  </v-text-field>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, toRefs, watch } from 'vue';
import { useTranslationStore, translation } from "~/plugins/store/translations";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: String as () => string | null,
    customerIndex: Number as () => number | null,
  },
  setup(props, { emit }) {
    const { modelValue, customerIndex } = toRefs(props);
    const companyName = ref(modelValue.value ? modelValue.value : '');
    const error = ref([]);

    watch(companyName, (newValue) => {
      const isValid = validateCompanyName(newValue);
      if (isValid) {
        emit('update:modelValue', newValue);
      } else {
        emit('update:modelValue', '');
      }
      if (customerIndex.value !== undefined) {
        emit('validation-customer-status', { field: `company_name-${customerIndex.value}`, isValid });
      } else {
        emit('validation-customer-status', { field: `company_name`, isValid });
      }
    });

    watch(modelValue, (newValue) => {
      if (newValue && validateCompanyName(newValue)) {
        companyName.value = newValue;
      }
    });

    const translationList = ref<TranslationList>({});
    const translationStore = useTranslationStore();

    const companyNameValidationRules = [
      (v: string) => !!v || translation(translationList.value.required, 'Acest câmp este obligatoriu'),
      (v: string) => (v && v.length >= 2) || translation(translationList.value.invalid_field, 'Acest câmp este invalid.'),
    ];

    function validateCompanyName(companyName: string, showErrors?: boolean): boolean {
      error.value = [];
      if (showErrors) {
        if (!companyName) {
          error.value = [translation(translationList.value.required, 'Acest câmp este obligatoriu')];
          return false;
        }
      }
      const result = companyName.length >= 2;

      if (showErrors) {
        if (!result) {
          error.value = [translation(translationList.value.invalid_field, 'Acest câmp este invalid.')];
          return false;
        }
      }
      return result;
    }

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      const isValid = validateCompanyName(companyName.value);
      if (customerIndex.value !== undefined) {
        emit('validation-customer-status', { field: `company_name-${customerIndex.value}`, isValid });
      } else {
        emit('validation-customer-status', { field: `company_name`, isValid });
      }

      // Listen for validate events
      window.addEventListener('validate-customer', handleValidationEvent);
      window.addEventListener('validate-travel', handleValidationEvent);
    });

    const handleValidationEvent = (data: any) => {
      if (data.detail && (data.detail === `company_name-${customerIndex.value}` || data.detail === `company_name`)) {
        const isValid = validateCompanyName(companyName.value, true);
        if (isValid) {
          emit('validation-customer-status', { field: data.detail, isValid });
        }
      }
    };

    return {
      companyName,
      companyNameValidationRules,
      translationList,
      translation,
      error,
    };
  },
});
</script>

<style scoped>
</style>